import React, { Component } from 'react';
import "./Home.css";

export default class Home extends Component {
    render() {
        return(
            <div className="Home">
                <div className="lander">
                    <h1>MOVEMANDU</h1>
                    <p> Welcome to the Movemandu Website!! </p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Home.js